import React from "react";

// ✅ Import images properly
import logo from "../image/logo.jpeg";
import logoWhite from "../image/logo.jpeg";
import heroBg from "../image/image1.png";
import { Link } from "react-router-dom";
import HomePage from "./homePage";
const Home = () => {
  return (
    <div className="font-sans text-gray-800">

      {/* ================= NAVBAR ================= */}
      <header className="w-full bg-white shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">

          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src={logo} alt="GoPhD Logo" className="h-10" />
          </div>

          {/* Menu */}
          <nav className="hidden md:flex gap-8 text-sm font-medium text-blue-900">
            <a href="#" className="hover:text-orange-500">Home</a>
            <a href="#" className="hover:text-orange-500">About Us</a>
            <a href="#" className="hover:text-orange-500">Policy Dialogues</a>
            <a href="#" className="hover:text-orange-500">Publications</a>
            <a href="#" className="hover:text-orange-500">Advisories</a>
            <a href="#" className="hover:text-orange-500">Events</a>
            <a href="#" className="hover:text-orange-500">Media</a>
          </nav>

          {/* CTA */}
          <button className="bg-orange-500 text-white px-5 py-2 rounded-md text-sm font-semibold hover:bg-orange-600">
            Join the Dialogue
          </button>
        </div>
      </header>

      {/* ================= HERO SECTION ================= */}
      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="">
          <div className="max-w-7xl mx-auto px-6 py-28 text-center">

            <h1 className="text-4xl md:text-5xl font-serif font-bold text-blue-900 leading-tight">
              Bridging Government Policy <br />
              and Public Health Voices
            </h1>

            <p className="mt-6 max-w-3xl mx-auto text-gray-700 text-lg">
              A global think tank fostering evidence-based public health
              dialogues between policymakers, experts, and the public.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              {/* Blue Button */}
              <button className="bg-blue-900 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-800">
                View Policy Briefs
              </button>

              {/* Orange Button */}
              <button className="bg-orange-500 text-white px-8 py-3 rounded-md font-semibold hover:bg-orange-600">
                Engage with Us
              </button>
            </div>

          </div>
        </div>
      </section>

      <div>
        <HomePage/>
      </div>

      {/* ================= FOOTER ================= */}
      <footer className="bg-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">

          {/* About */}
          <div>
            <img src={logoWhite} alt="GoPhD" className="h-10 mb-4" />
            <p className="text-sm text-blue-100 leading-relaxed">
              Global Diaspora for Public Health Dialogues (GoPhD) is a
              healthcare strategy think tank dedicated to fostering
              evidence-based public health dialogues.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-blue-100">
              <li>Home</li>
              <li>About Us</li>
              <li>Policy Dialogues</li>
              <li>Publications</li>
              <li>Advisories</li>
              <li>Events</li>
              <li>Media</li>
            </ul>
          </div>

          {/* Site Links */}
          <div>
            <h4 className="font-semibold mb-4">Site Links</h4>
            <ul className="space-y-2 text-sm text-blue-100">
              <li>Recommendations</li>
              <li>Research Papers</li>
              <li>Policy Briefs</li>
              <li>Media Coverage</li>
              <li>Contact Us</li>
              <li>Privacy Policy</li>
              <li>Disclaimer</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <p className="text-sm text-blue-100">1234 Policy Avenue</p>
            <p className="text-sm text-blue-100">New Delhi, India</p>
            <p className="text-sm text-blue-100 mt-2">+91 98765 43210</p>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <p className="text-sm text-blue-100 mb-4">info@gophd.org</p>

            <div className="flex">
              <input
                type="email"
                placeholder="Email address"
                className="w-full px-3 py-2 rounded-l-md text-gray-800 text-sm"
              />
              <button className="bg-orange-500 px-4 rounded-r-md font-semibold text-sm hover:bg-orange-600">
                Subscribe
              </button>
            </div>
          </div>

        </div>

        <div className="border-t border-blue-800 py-4 text-center text-sm text-blue-200">
          © 2024 GoPhD. All rights reserved. | Privacy Policy | Disclaimer
        </div>
      </footer>

    </div>
  );
};

export default Home;
